<template>
  <div class="dashboard">
    <mainmenu selected="dashboard"></mainmenu>
    <div class="container-fluid">
      <h1>{{$t('settings.page_title')}}</h1>

      <el-card class="box-card" v-loading="loadingVisible">
        
        <el-form ref="form" :model="form" >
          
          <el-form-item :label="$t('settings.smtp_host')" required>
             <el-input v-model="form.smtp_host"></el-input>
          </el-form-item>

          <el-form-item :label="$t('settings.smtp_port')" required>
             <el-input v-model="form.smtp_port"></el-input>
          </el-form-item>

          <el-form-item :label="$t('settings.smtp_user')" required>
             <el-input v-model="form.smtp_user"></el-input>
          </el-form-item>

          <el-form-item :label="$t('settings.smtp_pass')" required>
             <el-input v-model="form.smtp_pass"></el-input>
          </el-form-item>

          <el-form-item :label="$t('settings.system_email')" required>
             <el-input v-model="form.system_email"></el-input>
          </el-form-item>

          <el-form-item :label="$t('settings.system_name')" required>
             <el-input v-model="form.system_name"></el-input>
          </el-form-item>

          <el-form-item :label="$t('settings.system_delivery_notice_number')" required>
             <el-input v-model="form.first_delivery_note_internal_number"></el-input>
          </el-form-item>
          
          <el-form-item :label="$t('settings.invoice_email')"  required>
             <el-input v-model="form.invoice_department_email"></el-input>
          </el-form-item>

          <el-form-item :label="$t('settings.newsletter_subject')"  required>
             <el-input v-model="form.newsletter_subject"></el-input>
          </el-form-item>

          <el-form-item :label="$t('settings.newsletter_body')"  required>
             <el-input v-model="form.newsletter_body" type="textarea" autosize></el-input>
          </el-form-item>

          <el-form-item :label="$t('settings.new_request_subject')"  required>
             <el-input v-model="form.new_request_subject"></el-input>
          </el-form-item>

          <el-form-item :label="$t('settings.new_request_body')"  required>
             <el-input v-model="form.new_request_body" type="textarea" autosize></el-input>
          </el-form-item>

          <el-form-item :label="$t('settings.request_accepted_subject')"  required>
             <el-input v-model="form.request_accepted_subject"></el-input>
          </el-form-item>

          <el-form-item :label="$t('settings.request_accepted_body')"  required>
             <el-input v-model="form.request_accepted_body" type="textarea" autosize></el-input>
          </el-form-item>

          <el-form-item :label="$t('settings.request_rejected_subject')"  required>
             <el-input v-model="form.request_rejected_subject"></el-input>
          </el-form-item>

          <el-form-item :label="$t('settings.request_rejected_body')"  required>
             <el-input v-model="form.request_rejected_body" type="textarea" autosize></el-input>
          </el-form-item>

          <el-form-item :label="$t('settings.request_feedback_subject')"  required>
             <el-input v-model="form.request_feedback_subject"></el-input>
          </el-form-item>

          <el-form-item :label="$t('settings.request_feedback_message')"  required>
             <el-input v-model="form.request_feedback_message" type="textarea" autosize></el-input>
          </el-form-item>

          <el-form-item :label="$t('settings.bad_feedback_subject')"  required>
             <el-input v-model="form.bad_feedback_subject"></el-input>
          </el-form-item>

          <el-form-item :label="$t('settings.bad_feedback_message')"  required>
             <el-input v-model="form.bad_feedback_message" type="textarea" autosize></el-input>
          </el-form-item>

          <el-form-item :label="$t('settings.notify_powerusers_to_update_stocks_subject')"  required>
             <el-input v-model="form.notify_powerusers_to_update_stocks_subject"></el-input>
          </el-form-item>

          <el-form-item :label="$t('settings.notify_powerusers_to_update_stocks_message')"  required>
             <el-input v-model="form.notify_powerusers_to_update_stocks_message" type="textarea" autosize></el-input>
          </el-form-item>
          
          <el-form-item :label="$t('settings.monthly_notify_invoice_department_subject')"  required>
             <el-input v-model="form.monthly_notify_invoice_department_subject"></el-input>
          </el-form-item>
          

          <el-form-item>
            <el-button type="primary" @click="save">{{ $t("confirm") }}</el-button>
          </el-form-item>
          
        </el-form>

      </el-card>

    </div>
  </div>
</template>

<script>
import MainMenu from "./../widgets/MainMenu";
import settings from "./../backend/LocalSettings";

export default {
  name: "settings-page",
  components: {
    "mainmenu": MainMenu
  },
  data () {
    return { 
      loadingVisible: false,
      form: { smtp_host: "", smtp_port: "", smtp_user: "", smtp_pass: "", system_email: "", system_name: "" }
    }
  },
  methods: {
    refresh_info: function() {
      this.loadingVisible = true;
      this.$http
          .post('settings/refresh_info',  {} )
          .then(function (response) {
            this.loadingVisible = false;
            if( settings.verify_response(response, this.$rights) ) {
              this.form = response.body.Settings;
              this.PaginationInfo = response.body.PaginationInfo;
            } else {
              this.$router.push("/");
            }
          }); 
    },
    save: function(){
      this.loadingVisible = true;
      this.$http
          .post('settings/save',  { form: this.form } )
          .then(function (response) {
            this.loadingVisible = false;
            if( settings.verify_response(response, this.$rights) ) {
              this.$message( this.$t('settings.saved_success') );
            } else {
              this.$router.push("/");
            }
          }); 
    }
  },
  mounted: function() {
    this.refresh_info();
  }
};
</script>

<style lang="less" scoped>

</style>